import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getAllTags, deleteTag } from "./TagService";
import "./TagList.css";

export default function TagList() {
  const [tags, setTags] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    loadTags();
  }, []);

  const loadTags = async () => {
    const data = await getAllTags();
    setTags(data);
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this tag?")) return;
    await deleteTag(id);
    loadTags();
  };

  return (
    <div className="card">
      <button className="btn btn-primary" onClick={() => navigate("new")}>➕ Add Tag</button>

      <div className="data-table-wrap">
        <table className="tag-list-table">
          <thead>
            <tr>
              <th>Tag</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {tags.map(tag => (
              <tr key={tag.id}>
                <td>{tag.tagName}</td>
                <td>
                  <button className="btn" onClick={() => navigate(`edit/${tag.id}`)}>✏️</button>
                  <button className="btn btn-danger" onClick={() => handleDelete(tag.id)}>🗑️</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
